export const splitStringToArray = (value: string) => {
  // eslint-disable-next-line no-useless-escape
  return value.replace(/[\|\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?/\，/\。/\；/\：/\“/\”/\》/\《/\|/\{/\}/\、/\!/\~/\`]/g, ' ').replace(/\s+/g, ' ').split(' ')
}
